import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { getAction } from '@/api/manage';
import pick from 'lodash.pick';
import { duplicateCheck } from '@api/api';
export default {
  name: 'FactorModal',
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      factorTypeCode: 'factor_type_1',
      title: '环境监测因子表单',
      tableName: 'site_factor',
      form_fields: ['code', 'title', 'alias', 'category', 'st', 'past', 'restriction', 'lower', 'upper', 'monitorNum', 'intbits', 'decimals', 'unit', 'test', 'stat', 'warning', 'visible', 'status', 'sort', 'remark', 'tenantId'],
      form_fields_time: [],
      unitOptions: [],
      upper_status: true,
      lower_status: true,
      validatorRules: {
        code: {
          rules: [{
            required: true,
            message: '请输入编号!'
          }, {
            validator: this.validateFactorCode
          }]
        },
        title: {
          rules: [{
            required: true,
            message: '请输入名称!'
          }]
        },
        category: {
          rules: [{
            required: true,
            message: '请输入类型!'
          }]
        },
        st: {
          rules: [{
            required: true,
            message: '请选择系统编码!'
          }]
        },
        intbits: {
          rules: [{
            required: true,
            message: '请输入整数位!'
          }]
        },
        decimals: {
          rules: [{
            required: true,
            message: '请输入小数位!'
          }]
        },
        unit: {
          rules: [{
            required: true,
            message: '请输入数据单位!'
          }]
        },
        monitorNum: {
          rules: [{
            required: true,
            message: '请输入每日监测次数!'
          }]
        },
        stat: {
          rules: [{
            required: true,
            message: '请输入统计方法!'
          }]
        },
        warning: {
          rules: [{
            required: true,
            message: '请输入是否预警!'
          }]
        },
        visible: {
          rules: [{
            required: true,
            message: '请输入数据可见性!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请输入状态!'
          }]
        },
        sort: {
          rules: [{
            required: true,
            message: '请输入排序号!'
          }]
        }
      }
    };
  },
  props: ['pagePath'],
  created: function created() {
    this.queryUnitList();
  },
  methods: {
    close: function close() {
      this.factorTypeCode = '';
      this.$emit('close');
      this.visible = false;
    },
    queryUnitList: function queryUnitList() {
      var _this = this;

      var params = {
        pageNo: 1,
        pageSize: 10000,
        status: '1'
      };
      getAction('/site/factor/unit', params).then(function (res) {
        if (res.success) {
          _this.unitOptions = res.result.records;
        } else {
          console.log(res.message);
        }
      });
    },
    edit: function edit(record) {
      var _this2 = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);

      if (this.model.st) {
        this.factorTypeCode = 'factor_type_' + this.model.st;
      } else {
        this.factorTypeCode = 'factor_type_1';
      }

      this.visible = true;
      this.upper_status = false;
      this.lower_status = false;
      this.$nextTick(function () {
        var that = _this2; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item]) : null;
        });
        that.form.setFieldsValue(timeVal);
      });
    },
    handleChangeSt: function handleChangeSt(value) {
      this.factorTypeCode = 'factor_type_' + value;
    },
    handleChangeRestriction: function handleChangeRestriction(value) {
      if (value == 2 || value == 4) {
        this.upper_status = false;
        this.lower_status = true;
        this.model.lower = ' ';
      } else if (value == 3 || value == 5) {
        this.upper_status = true;
        this.lower_status = false;
        this.model.upper = ' ';
      } else if (value == 1) {
        this.upper_status = true;
        this.lower_status = true;
      } else if (value == '') {
        this.upper_status = false;
        this.lower_status = false;
      }
    },
    validateFactorCode: function validateFactorCode(rule, value, callback) {
      // 重复校验
      var params = {
        tableName: 'site_factor',
        fieldName: 'code',
        fieldVal: value,
        dataId: this.model.id
      };
      duplicateCheck(params).then(function (res) {
        if (res.success) {
          callback();
        } else {
          callback(res.message);
        }
      });
    }
  }
};